const API_BASE = 'https://api.dev.auxo.dk';

function buildQuery(params = {}) {
  const search = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;

    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== null && item !== '') {
          search.append(key, item);
        }
      });
      return;
    }

    search.set(key, value);
  });

  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

async function fetchJson(url, options = {}) {
  const response = await fetch(url, options);

  if (!response.ok) {
    const error = new Error(`CMS request failed with status ${response.status}`);
    error.status = response.status;
    throw error;
  }

  return response.json();
}

export async function fetchCmsCollection(collectionName, options = {}) {
  const {
    endpoint = 'v2',
    limit = 25,
    offset = 0,
    sort = 'updatedAt',
    order = 'desc',
    term = [],
  } = options;

  const params = { limit, offset, sort, order, term };

  if (endpoint === 'raw') {
    return fetchJson(`${API_BASE}/public/content/${collectionName}`);
  }

  return fetchJson(`${API_BASE}/public/v2/content/${collectionName}${buildQuery(params)}`);
}

export async function fetchCmsEntryBySlug(slug, lang = 'da') {
  return fetchJson(`${API_BASE}/public/by-slug/${lang}/${slug}`);
}

export async function fetchCmsEntryById(collectionName, entryId) {
  return fetchJson(`${API_BASE}/public/content/${collectionName}/${entryId}`);
}
